import React, { useEffect, useState, Fragment } from 'react';

import Head from 'next/head';

import { connect } from 'react-redux';

import { string, object, number } from 'prop-types';

const GtmScriptComponent = ({ gtmId, cookiesPolicy, gaId, siteId, aiChatAmmi }) => {
  const [initialize, setInitialize] = useState(false);

  useEffect(() => {
    setInitialize(true);
  }, []);

  return (
    <Fragment>
      {initialize && (
        <Head key="gtm-script">
          {/* <<< Google Analytics >>> */}
          {gaId && (
            <script
              dangerouslySetInnerHTML={{
                __html: `window.ga=window.ga || function() {(ga.q = ga.q || []).push(arguments)};
      ga.l=+new Date;
      ga('create', '${gaId}', 'auto');
      ga('require', 'ec');
      ${!cookiesPolicy.getIn(['accepted']) ? `ga('set', 'anonymizeIp', true)` : ''};
      ga('send', 'pageview');`,
              }}
            />
          )}
          {gaId && <script async src="https://www.google-analytics.com/analytics.js" />}

          {/* <<< Google Tag Manager >>> */}
          {gtmId && cookiesPolicy.getIn(['accepted']) && (
            <script
              dangerouslySetInnerHTML={{
                __html: `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
          new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
          j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.defer=true;j.src=
          'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
        })(window,document,'script','dataLayer','${gtmId}');`,
              }}
            />
          )}

          <script src={aiChatAmmi?.getIn(['script'])} />
          {/* <script */}
          {/*   dangerouslySetInnerHTML={{ */}
          {/*     __html: ` */}
          {/*         window.onload = function () { */}
          {/*           if (window.ChatWidget) { */}
          {/*             ChatWidget.init('${aiChatAmmi?.getIn(['agent'])}','${aiChatAmmi.getIn(['chatColor']) || ''}'); */}
          {/*           } else { */}
          {/*             console.error("ChatWidget não está definido."); */}
          {/*           } */}
          {/*         }; */}
          {/*         `, */}
          {/*   }} */}
          {/*   defer */}
          {/* /> */}
        </Head>
      )}
    </Fragment>
  );
};

GtmScriptComponent.propTypes = {
  gtmId: string,
  cookiesPolicy: object,
  gaId: string,
  siteId: number,
  aiChatAmmi: object,
};

const mapStateToProps = ({ app }) => ({
  cookiesPolicy: app.getIn(['cookiesPolicy']),
  gtmId: app.getIn(['config', 'gtmId']),
  gaId: app.getIn(['config', 'gaId']),
  siteId: app.getIn(['config', 'siteId']),
  aiChatAmmi: app.getIn(['config', 'showComponents', 'aiChatAmmi']),
});

export const GtmScript = connect(mapStateToProps)(GtmScriptComponent);

export function loadGtmNoScript(gtmId, acceptsCookiesPolicy) {
  if (typeof document !== 'undefined' && gtmId && acceptsCookiesPolicy) {
    setTimeout(() => {
      const n = document.createElement('noscript');
      const i = document.createElement('iframe');
      i.title = 'no-script-GTM';
      i.src = `https://www.googletagmanager.com/ns.html?id=${gtmId}`;
      i.height = '0';
      i.width = '0';
      i.style.display = 'none';
      i.style.visibility = 'hidden';

      n.appendChild(i);

      document.body.insertBefore(n, document.body.firstChild);
    }, 1000);
  }
}
